/** @format */

import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  Jumbotron,
  Button,
  Collapse,
  FormGroup,
  Form,
  CustomInput,
} from "reactstrap";
import products from "../data/products-clothes.json";
import CardProduct from "../components/CardProduct";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";
import Icon from "../components/Icon";
import jquery from "jquery";
import Select from "react-select";
import Filters from "../components/Filters";
import {
  setCookie,
  getCookie,
  eraseCookie,
  setLocalStorage,
  getLocalStorage,
  getUrlParam,
  setCookieOneHr,
} from "../global/browserFunctions";
import colors from "../data/colors.json";
import sizes from "../data/sizes.json";
import { showNotification } from "../global/notification";
import Loader from "../components/Loader";
import _ from "underscore";
import { category, category2, categoryJSON } from "../global/url";
import Nouislider from "nouislider-react";
import { EqualHeight, EqualHeightElement, EqualHeightConsumer } from 'react-equal-height';

class CategoryFull extends Component {
  constructor(props) {
    super(props);

    if (!getCookie("log")) {
      // if not logged in, go to login page
      this.GoToPage("/");
    }
    var pageNum = getUrlParam("page") ? Number(getUrlParam("page")) : 1; //Get current page number
    var filters = getUrlParam("filters")
      ? JSON.parse(decodeURIComponent(getUrlParam("filters"))) //Get filters selected if any
      : {};
    filters = typeof filters == "object" ? filters : {};
    this.options = [
      {
        value: "alphaAZ",
        label: "Item Name: A-Z",
      },
      {
        value: "alphaZA",
        label: "Item Name: Z-A",
      },
      {
        value: "asc",
        label: "Low-High",
      },
      {
        value: "desc",
        label: "High-Low",
      },
    ]; //Sort options are set as static
    var sort = getUrlParam("sort")
      ? JSON.parse(decodeURIComponent(getUrlParam("sort")))
      : this.options[0]; //Get sort options from URL if any
    sort = typeof sort == "object" ? sort : this.options[0];
    this.state = {
      productsFull: products, //All items
      pagedData: [],
      img: "",
      price: "",
      name: "",
      currentPage: pageNum - 1, //Page number
      data: null,
      cartCount: getCookie('cartCount') || 0,
      items: [],
      isLoaded: false,
      colors: colors, //not used, static colors
      size: sizes, //not used, static size
      bicycleColor: [],
      bicycleSize: [],
      bicycleSpeed: [],
      stock_availability: [{
        "value": "true",
        "text": "In Stock",
        "uniqIndex": 111
      }],
      accSize: [],
      accColor: [],
      priceMin: filters.filterPriceMin || 0, //If filter prize else 0
      priceMax: filters.filterPriceMax || 2000, //If filter prize else 2000
      priceStartRange: 0,
      priceEndRange: 2000,
      filterInputs: filters, //Filter object from URL
      sortOption: sort,
      loading: true, //Show lodaing
      categoryName: "",
      description: "",
      collapse: { Size: false, Color: false }, //Object initializing for toggle collapse filter in small devices
      sidebarFilters: [], //Array of filters, dynamically populated from items
    };

    this.priceMin = this.state.priceMin;
    this.priceMax = this.state.priceMax;

    this.PAGE_SIZE = 15; // ITEMS PER PAGE
    this.onFilterSubmit = this.onFilterSubmit.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.toggleCollapse = this.toggleCollapse.bind(this);
    this.priceSlider = this.priceSlider.bind(this);
    this.updateCartCount = this.updateCartCount.bind(this);

    this.customSelectStyles = {
      //CUSTOM STYLE FOR SELECT
      control: (provided, state) => ({
        ...provided,
        border: "1px solid #ced4da",
        borderRadius: "0",
        width: 200,
        cursor: "pointer",
      }),
      indicatorSeparator: (provided, state) => ({
        display: "none",
      }),
      menu: (provided, state) => ({
        ...provided,
        color: "#343a40",
        border: "0 solid #fff",
        borderRadius: 0,
        boxShadow: "0 0 1.2rem rgba(0, 0, 0, .15)",
      }),
      option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
        ...provided,
        backgroundColor: isDisabled
          ? null
          : isSelected
            ? "#bcac76"
            : isFocused
              ? "#eee"
              : null,
        ":active": {
          ...provided[":active"],
          backgroundColor: "#e2dabc",
        },
        cursor: "pointer",
      }),
    };
    this.myRef = React.createRef();
    //this.setPageData()
  }

  updateCartCount(count) {
    console.log('count', count)
    this.setState({ cartCount: count });
    this.forceUpdate();
  }

  priceSlider(render, handle, value, un, percent) {
    //Function handle price slider change
    this.setState({ priceMin: value[0].toFixed(0) });
    this.setState({ priceMax: value[1].toFixed(0) });

    var filterInputs = { ...this.state.filterInputs };
    filterInputs["filterPriceMin"] = value[0].toFixed(0);
    filterInputs["filterPriceMax"] = value[1].toFixed(0);

    this.setState({ filterInputs: filterInputs });
  }

  onInputChange(e) {
    //Function to handle filter apply, unapply changes
    var type = e.target.type; // Input type
    var id = e.target.id; // Input value
    var value = jquery("#" + id).attr("data-content"); //Id of filter store as custom attribute, otherwise the check will not work
    var name = e.target.name; // Input name
    var filters = { ...this.state.filterInputs };

    if (this.state.filterInputs[name]) {
      if (this.state.filterInputs[name].some((item) => item === value)) {
        filters[name] = this.state.filterInputs[name].filter(
          (x) => x !== value
        ); //setting value to filter array, check already exist if yes, delete or create obj
        this.setState({ filterInputs: filters });
      } else {
        filters[name].push(value);
        this.setState({ filterInputs: filters });
      }
    } else {
      filters[name] = [];
      filters[name].push(value);
      this.setState({ filterInputs: filters });
    }

    // console.log(this.state);
  }

  toggleCollapse(name) {
    //Toggle collapse for filters
    var collapseState = { ...this.state.collapse };
    collapseState[name] = !collapseState[name];
    this.setState({ collapse: collapseState });
  }

  componentDidMount() {
    this.setPageData(); //After component is rendered, will set filters and other details using items
    this.myRef.current.scrollIntoView(); //Each time component is rendered go to top, this is helpful when pagination and filter/sort works
    //window.scrollTo(0, 0)
  }

  setPageData() {
    var pagedData = [];

    //this.fetchItems2();
    var pageNum = getUrlParam("page") ? Number(getUrlParam("page")) : 1; //Get page number from url param else 1
    var itemsPaginated = [];
    var id = getUrlParam("id");
    var details = getLocalStorage(id) ? JSON.parse(getLocalStorage(id)) : false; //If item details is available in local storage get else fetch
    if (getCookie(id)) {
      //If last fetch was done before 1 hour, use localstorage data else fetch. This is done for getting stock info
      //console.log("items", items);
      if (details) {
        var items = details.items;
        var itemsForFilter = JSON.stringify(items);
        setTimeout(() => {
          //Timeout to set filters otherwise will not render in UI
          this.createFilterElements(itemsForFilter);
        }, 200);
        items = this.isSortApplied(items); // Fuction to sort product, if sort applied
        items = this.isFilterApplied(items); // Fuction to filter product, if filter applied
        var category = details.categories[0];
        if (category) {
          document.title = category.name.value;
          this.setState({ categoryName: category.name.value });
          this.setState({ description: category.longdescription.value }); // Set category name and decsription
        }
        if (items.length > 0) {
          //If items found
          pagedData =
            Array.isArray(items) && items.length
              ? this.chunkArray(items, this.PAGE_SIZE) //Set 8 items per page
              : [];
          //console.log('pagedData',pagedData)
          this.setState({ pagedData: pagedData });
          itemsPaginated = pagedData[pageNum - 1] || [];
          this.setState({ items: itemsPaginated });
        }
        this.setState({ loading: false }); //Stop loader
      } else {
        var items = this.fetchItems(id); //Fetch item request
      }
    } else {
      var items = this.fetchItems(id);
    }
  }

  isSortApplied(items) {
    var sort = getUrlParam("sort")
      ? JSON.parse(decodeURIComponent(getUrlParam("sort")))
      : {}; //if sort params found
    if (Object.keys(sort).length != 0) {
      if (sort.value == "asc") {
        return items.sort(this.dynamicSort("item_baseprice", 1)); //Sort ascending
      } else if (sort.value == "desc") {
        return items.sort(this.dynamicSort("item_baseprice", -1)); //Sort descending
      } else if (sort.value == "alphaAZ") {
        return items.sort(this.dynamicSort("item_itemid", 1)); //Sort ascending
      } else if (sort.value == "alphaZA") {
        return items.sort(this.dynamicSort("item_itemid", -1)); //Sort descending
      } else {
        return items.sort(this.dynamicSort("item_itemid", 1));
      }
    } else {
      return items.sort(this.dynamicSort("item_itemid", 1));
    }
  }

  dynamicSort(property, sortOrder) {
    //Sort item order
    return function (a, b) {
      var result =
        a[property].value < b[property].value
          ? -1
          : a[property].value > b[property].value
            ? 1
            : 0;
      return result * sortOrder;
    };
  }

  isFilterApplied(items) {
    var filters = getUrlParam("filters")
      ? JSON.parse(decodeURIComponent(getUrlParam("filters")))
      : {}; //Get all filter params
    var filteredItems = [];
    var shouldFilterApply = false;

    for (var key in filters) {
      if (key != "filterPriceMax" && key != "filterPriceMin") {
        shouldFilterApply =
          filters[key].length > 0
            ? shouldFilterApply || true
            : shouldFilterApply || false;
      }
    } //To check whether to apply all filter or not. This done to handle when user click apply filter without selecting any filters

    if (Object.keys(filters).length != 0) {
      //Get inside if any filters is selected
      var priceMin = parseInt(filters.filterPriceMin);
      var priceMax = parseInt(filters.filterPriceMax); //Get min and max price

      if (shouldFilterApply) {
        for (var i in items) {
          var flag = "NA"; //flag is set to work && operation. Since in loop everything has to be dynamic. First flag will neither false nor true, it will be NA
          var itemOptions = {
            //Obj initialized to store 5 matrix option filters. Since this is static, client should give predefined set of mtarix option that they use in website
            stock_availability: [],
            item_custitembicyclesize: [],
            item_custitembicyclecolor: [],
            item_custitembicyclespeed: [],
            item_custitembicycleaccessorycolor: [],
            item_custitembicycleaccessorysize: [],
          };
          var children = items[i].child_items || {};
          for (var child in children) {
            var value = this.createItemOptions(children[child], itemOptions);
          } //Get all child and set matrix options that will be used in filters

          var itemId = items[i].item_internalid.value; //Get item id
          console.log(itemOptions, 'matrixOptions')
          for (var j in filters) {
            if (j != "filterPriceMax" && j != "filterPriceMin") {
              //If filter not realted to price, get inside.
              var filterValue = filters[j];
              filterValue = _.without(filterValue, ""); //To remove any null values from array
              if (Object.keys(children).length != 0) {
                var matrixOptions = itemOptions[j] || []; //To get all options from parent items, because no child for this item

                matrixOptions = _.without(matrixOptions, "") || []; //To remove any null values from array
              } else {
                var matrixOptions = items[i][j].value.split(",") || []; //To get all options from child items
                matrixOptions = _.without(matrixOptions, "") || [];
              }

              var matchedValues = []; //Matched matrix option from selected filter

              filterValue.forEach((x) => {
                if (matrixOptions.indexOf(x) != -1) {
                  matchedValues.push(x);
                }
              }); //Fnction to filter item

              if (filterValue.length > 0) {
                //   if (matrixOptions.length > 0) {
                // var diffeeneceInArr = _.difference(matrixOptions, filterValue);
                // diffeeneceInArr = _.without(diffeeneceInArr, "");

                // console.log('diffeeneceInArr'+ " "+diffeeneceInArr+" "+matrixOptions);

                if (matchedValues.length > 0) {
                  flag = flag == "NA" ? true : flag && true; //If all filter criteria is passed then, falg will be true
                  //   console.log('if'+ " "+items[i].item_itemid.value+" "+flag);
                } else {
                  flag = flag == "NA" ? false : flag && false; //If all filter criteria is not passed then, flag will be false
                  //   console.log('else'+ " "+items[i].item_itemid.value+" "+flag);
                }
                //   }
              }
            }
          }

          // console.log('final'+ " "+items[i].item_itemid.value+" "+flag);
          if (flag == true) {
            //If an item matches all criteria
            var basePriceLevel = "1";
            var price = (items[i].price_levels && items[i].price_levels[basePriceLevel] && items[i].price_levels[basePriceLevel].item___pricing_unitprice.value) || "";
            if (price == "") {
              var child = items[i].child_items;
              child = child[Object.keys(child)[0]];
              price = Object.keys(child).length > 0 ? (child.price_levels[basePriceLevel] && child.price_levels[basePriceLevel].item___pricing_unitprice.value) : price;
            }
            var index = filteredItems.findIndex(
              (x) => x.item_internalid.value == itemId
            ); //Check whether the item is already in array else add item

            if (price) {
              // Compare price filter before adding the item to array
              price = parseInt(price);
              if (price >= priceMin && price <= priceMax) {
                if (index == -1) {
                  //if item not existing in array, add item
                  filteredItems.push(items[i]);
                }
              }
            } else {
              if (index == -1) {
                filteredItems.push(items[i]);
              }
            }
          }
        }
        return filteredItems;
      } else {
        // If no filter other than price is applied, get into this set of logic
        for (var i in items) {
          var basePriceLevel = "1";
          var price = (items[i].price_levels && items[i].price_levels[basePriceLevel] && items[i].price_levels[basePriceLevel].item___pricing_unitprice.value) || "";
          if (price == "") {
            var child = items[i].child_items;
            child = child[Object.keys(child)[0]];
            price = Object.keys(child).length > 0 ? (child.price_levels[basePriceLevel] && child.price_levels[basePriceLevel].item___pricing_unitprice.value) : price;
          }
          var index = filteredItems.findIndex(
            (x) => x.item_internalid.value == itemId
          );
          if (price) {
            //Only comparing the price before adding the item filtered items array
            price = parseInt(price);
            if (price >= priceMin && price <= priceMax) {
              if (index == -1) {
                filteredItems.push(items[i]);
              }
            }
          } else {
            if (index == -1) {
              filteredItems.push(items[i]);
            }
          }
        }

        return filteredItems;
      }
    } else {
      return items;
    }
  }

  createItemOptions(child, itemOptions) {
    //Function to create all matrix option from child item
    var keys = _.keys(itemOptions);
    for (var i in keys) {
      if (child[keys[i]].value != "") {
        if (child[keys[i]].value === undefined) {
          var objects = child[keys[i]]
          console.log(objects, "onject")
          if (objects[Object.keys(objects)[0]].item_locationquantityavailable_text.value === "OUT OF STOCK" && objects[Object.keys(objects)[1]].item_locationquantityavailable_text.value === "OUT OF STOCK") {
            itemOptions[keys[i]].push("false");
          }
          else {
            itemOptions[keys[i]].push("true");
          }
        } else {
          itemOptions[keys[i]].push(child[keys[i]].value);
        }



      }
    }

    return true;
  }

  createFilterElements(items) {
    //Function to create filter elements
    items = typeof items == "object" ? items : JSON.parse(items);
    var filter = {
      Stock: "stock_availability",
      bicycleColor: "item_custitembicyclecolor",
      bicycleSize: "item_custitembicyclesize",
      bicycleSpeed: "item_custitembicyclespeed",
      accSize: "item_custitembicycleaccessorysize",
      accColor: "item_custitembicycleaccessorycolor",
    }; //Only 5 matrix options are considered fro creating the filters
    var keys = _.keys(filter);
    var priceMax = 0;
    var basePriceLevel = "1";
    for (var i in items) {
      var child = items[i].child_items || {};
      for (var j in child) {
        var baseprice = (child[j].item_baseprice && child[j].item_baseprice.value) || "";
        var price = (child[j].price_levels[basePriceLevel] && child[j].price_levels[basePriceLevel].item___pricing_unitprice.value) || baseprice; //Create price filter based on child item prices
        price = Math.ceil(parseFloat(price));
        if (price > priceMax) {
          priceMax = price;
          this.setState({ priceMax: price });
          this.setState({ priceEndRange: price });
          //this.priceMax=price;
        }
      }
    }

    for (var i in keys) {
      var randomNum = Math.floor(Math.random() * (99999 - 1)) + 1;
      var FilterArr = this.createFilters(filter[keys[i]], items, randomNum);
      FilterArr = _.sortBy(FilterArr, "text");
      this.setState({ [keys[i]]: FilterArr });
    }

    const CheckboxesFilter = (
      { data, idd } //Checkbox component
    ) => (
      <Form className="mt-4 mt-lg-0">

        {data.map((item) => (
          <FormGroup key={item.uniqIndex} className="mb-1">
            <CustomInput
              type="checkbox"
              name={idd}
              data-content={item.value}
              id={item.uniqIndex}
              label={<React.Fragment>{item.text}</React.Fragment>}
              checked={
                this.state.filterInputs[idd]
                  ? this.state.filterInputs[idd].includes(item.value)
                  : ""
              }
              onChange={(e) => this.onInputChange(e)}
            />
          </FormGroup>
        ))}
      </Form>
    );

    this.sidebarFilters = [
      {
        component: (
          <CheckboxesFilter
            data={this.state.stock_availability}
            idd="stock_availability"
          />
        ),
        title: "Filter By stock",
        subtitle: "In Stock",
        show: this.state.stock_availability.length == 0 ? false : true,
      },
      {
        component: (
          <CheckboxesFilter
            data={this.state.bicycleSize}
            idd="item_custitembicyclesize"
          />
        ),
        title: "Filter by Bicycle Size",
        subtitle: "Size",
        show: this.state.bicycleSize.length == 0 ? false : true,
      },
      {
        component: (
          <CheckboxesFilter
            data={this.state.bicycleColor}
            idd="item_custitembicyclecolor"
          />
        ),
        title: "Filter by Bicycle Color",
        subtitle: "Color",
        show: this.state.bicycleColor.length == 0 ? false : true,
      },
      {
        component: (
          <CheckboxesFilter
            data={this.state.bicycleSpeed}
            idd="item_custitembicyclespeed"
          />
        ),
        title: "Filter by Bicycle Speed",
        subtitle: "Speed",
        show: this.state.bicycleSpeed.length == 0 ? false : true,
      },
      {
        component: (
          <CheckboxesFilter
            data={this.state.accSize}
            idd="item_custitembicycleaccessorysize"
          />
        ),
        title: "Filter by Accessory Size",
        subtitle: "Accessory Size",
        show: this.state.accSize.length == 0 ? false : true,
      },
      {
        component: (
          <CheckboxesFilter
            data={this.state.accColor}
            idd="item_custitembicycleaccessorycolor"
          />
        ),
        title: "Filter by Accessory Color",
        subtitle: "Accessory Color",
        show: this.state.accColor.length == 0 ? false : true,
      },
    ];

    this.setState({ sidebarFilters: this.sidebarFilters });
    //console.log('1', JSON.stringify(this.state))
    this.forceUpdate();
    return true;
  }

  createFilters(key, items, uniqIndex) {
    //Function to create filter options object
    var arr = [];
    for (var i in items) {
      // var matrixOption = items[i][key];
      // if (matrixOption.value != "") {
      // 	var value = matrixOption.value.split(",");
      // 	var text = matrixOption.text.split(",");
      // 	for (var j in value) {
      // 		var obj = {};
      // 		obj.name = text[j];
      // 		obj.value = value[j];
      // 		obj.uniqIndex = uniqIndex;
      // 		arr.push(obj);
      // 		++uniqIndex;
      // 	}
      // }
      var childItems = items[i].child_items || {};
      for (var j in childItems) {
        var obj = childItems[j][key] || { value: "" };
        if (obj.value != "") {
          obj.uniqIndex = uniqIndex;
          arr.push(obj);
          ++uniqIndex;
        }
      }
    }
    var filteredArr = arr.reduce((acc, current) => {
      //If option already exist then it wont be added to the array
      const x = acc.find((item) => item.value === current.value);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);
    //console.log('filteredArr',filteredArr)

    return filteredArr;
  }

  onFilterSubmit() {
    // Function that applied when user click on apply filter button
    var categoryID = getUrlParam("id");
    this.props.history.push({
      pathname: "/category",
      search:
        "?id=" +
        categoryID +
        "&filters=" +
        encodeURIComponent(JSON.stringify(this.state.filterInputs)),
    });

    window.location.reload(); // The page is reloaded each time a sort/filter is applied
  }
  GoToPage(path) {
    this.props.history.push(path);
  }

  handleSort(e) {
    //Function that works when user select a sort option from the select box
    this.setState({ sortOption: e });
    var categoryID = getUrlParam("id");
    var filters = getUrlParam("filters");

    // var query= '?'+filters!=null?"filters="+filters:'';
    // query+=filters!=null?'&sort='+JSON.stringify(e):'sort='+JSON.stringify(e);
    var query = "?";
    query += "id=" + categoryID;

    if (filters != null) query += "&filters=" + filters;

    if (filters != null) query += "&sort=" + JSON.stringify(e);
    else query += "&sort=" + encodeURIComponent(JSON.stringify(e));

    this.props.history.push({
      pathname: "/category",
      search: query,
    });

    window.location.reload(); // The page is reloaded each time a sort/filter is applied
  }

  handleClick(e, index) {
    //Function that triggers pagination
    e.preventDefault();
    if (index >= 0 && index <= this.state.pagedData.length - 1) {
      this.setState({ currentPage: index });
      this.setState({ items: this.state.pagedData[index] });
      this.myRef.current.scrollIntoView();
      window.scrollTo(0, 0);
      var filters = getUrlParam("filters");
      var sort = getUrlParam("sort");
      var categoryID = getUrlParam("id");

      // var query= '?'+filters!=null?"filters="+filters+'&page=' + ++index : 'page=' + ++index;
      // query+=filters!=null? sort!=null?'&sort='+sort:'sort='+sort +'&page=' + ++index : 'page=' + ++index;

      var query = "?";
      query += "id=" + categoryID;
      if (filters != null) query += "&filters=" + filters; //check for filters and apply with pagination

      if (filters != null && sort != null)
        //Check for filters and sort option
        query += "&sort=" + sort + "&page=" + ++index;
      else if (sort != null) query += "&sort=" + sort + "&page=" + ++index;
      else query += "&page=" + ++index;

      this.props.history.push({
        pathname: "/category",
        search: query,
      });
    }
  }

  fetchItems(id) {
    //Fetch items based on the category
    var self = this;
    var currencyObj = { "1": "USD", "3": "CAD", 1: "USD", 3: "CAD" }
    var currency = getCookie("currency");
    var pricelevel = getCookie("pricelevel") || "5";
    var query = "&priceLevel=" + pricelevel + "&currencyId=" + currency;

    var categoryObj = window.CategoryDetails || [];

    this.intervalID = setInterval(function () { //This will load the json file again if we dont get the data first time
      var categoryObj = window.CategoryDetails || {};
      if (categoryObj) {
        clearInterval(self.intervalID)
        self.setState({ loading: false });

        var pageNum = getUrlParam("page") ? Number(getUrlParam("page")) : 1;
        setCookieOneHr(id, true, 1);
        var data = categoryObj[currencyObj[currency]];
        console.log('details', details)
        var details = data[id];


        if (details) {
          var items = details.items;
          items = self.isSortApplied(items);
          items = self.isFilterApplied(items);
          var category = details.categories[0];
          self.setState({ categoryName: category.name.value });
          document.title = category.name.value;
          self.setState({ description: category.longdescription.value });
          setLocalStorage(id, JSON.stringify(details));

          if (items.length > 0) {
            var pagedData =
              Array.isArray(items) && items.length
                ? self.chunkArray(items, self.PAGE_SIZE)
                : [];

            self.setState({ pagedData: pagedData });
            var itemsPaginated = pagedData[pageNum - 1] || [];
            self.setState({ items: itemsPaginated });
          }
          var test = self.createFilterElements(items);
        }
      }

    }, 200)
    // jquery
    //   .ajax({
    //     url: category2 + "&categoryId=" + id + query,
    //     dataType: "jsonp",
    //   })
    //   .done(function (data) {
    //     self.setState({ loading: false });
    //     if (data) {
    //       var pageNum = getUrlParam("page") ? Number(getUrlParam("page")) : 1;
    //       data = JSON.parse(unescape(data));
    //       console.log('data',data)
    //       if (data.summary.status == "SUCCESS") {
    //         //   console.log("data", data);
    //         setCookieOneHr(id, true, 1);
    //         var details = data.data;
    //         if (details) {
    //           var items = details.items;
    //           items = self.isSortApplied(items);
    //           items = self.isFilterApplied(items);
    //           var category = details.categories[0];
    //           self.setState({ categoryName: category.name.value });
    //           document.title = category.name.value;
    //           self.setState({ description: category.longdescription.value });
    //           setLocalStorage(id, JSON.stringify(details));

    //           if (items.length > 0) {
    //             var pagedData =
    //               Array.isArray(items) && items.length
    //                 ? self.chunkArray(items, self.PAGE_SIZE)
    //                 : [];

    //             self.setState({ pagedData: pagedData });
    //             var itemsPaginated = pagedData[pageNum - 1] || [];
    //             self.setState({ items: itemsPaginated });
    //           }
    //           var test = self.createFilterElements(items);
    //         }
    //       } else {
    //         console.log("err in fetch");
    //       }
    //     } else {
    //       console.log("err in fetch");
    //     }
    //   });

  }

  // fetchItems(id) {
  //   //Fetch items based on the category
  //   var self = this;
  //   var currency = getCookie("currency");
  //   var pricelevel = getCookie("pricelevel") || "5";
  //   var query = "&priceLevel=" + pricelevel + "&currencyId=" + currency;

  //   jquery
  //     .ajax({
  //       url: category2 + "&categoryId=" + id + query,
  //       dataType: "jsonp",
  //     })
  //     .done(function (data) {
  //       self.setState({ loading: false });
  //       if (data) {
  //         var pageNum = getUrlParam("page") ? Number(getUrlParam("page")) : 1;
  //         data = JSON.parse(unescape(data));
  //         console.log('data',data)
  //         if (data.summary.status == "SUCCESS") {
  //           //   console.log("data", data);
  //           setCookieOneHr(id, true, 1);
  //           var details = data.data;
  //           if (details) {
  //             var items = details.items;
  //             items = self.isSortApplied(items);
  //             items = self.isFilterApplied(items);
  //             var category = details.categories[0];
  //             self.setState({ categoryName: category.name.value });
  //             document.title = category.name.value;
  //             self.setState({ description: category.longdescription.value });
  //             setLocalStorage(id, JSON.stringify(details));

  //             if (items.length > 0) {
  //               var pagedData =
  //                 Array.isArray(items) && items.length
  //                   ? self.chunkArray(items, self.PAGE_SIZE)
  //                   : [];

  //               self.setState({ pagedData: pagedData });
  //               var itemsPaginated = pagedData[pageNum - 1] || [];
  //               self.setState({ items: itemsPaginated });
  //             }
  //             var test = self.createFilterElements(items);
  //           }
  //         } else {
  //           console.log("err in fetch");
  //         }
  //       } else {
  //         console.log("err in fetch");
  //       }
  //     });
  // }

  // fetchItems(id) {
  //   var self = this;
  //   var currency = getCookie("currency");
  //   var pricelevel = getCookie("pricelevel") || "5";


  // }

  // fetchItems(id) {
  // 	var self = this;
  // 	jquery
  // 		.ajax({
  // 			url: category + "&category=" + id + "&router=getcategory",
  // 			dataType: "jsonp",
  // 		})
  // 		.done(function (data) {
  // 			self.setState({ loading: false });
  // 			data = JSON.parse(data);
  // 			var pageNum = getUrlParam("page") ? Number(getUrlParam("page")) : 1;
  // 			if (data[0].responseString == "Success") {
  // 				setCookieOneHr(id, true, 1);
  // 				var details = data[0].responseMessage;
  // 				details = unescape(details);
  // 				details = JSON.parse(details);

  // 				if (details) {
  // 					var items = details.items;
  // 					var category = details.category;
  // 					self.setState({ categoryName: category.name });
  // 					self.setState({ description: category.longdescription });
  // 					setLocalStorage(id, JSON.stringify(details));
  // 					if (items.length > 0) {
  // 						var pagedData =
  // 							Array.isArray(items) && items.length
  // 								? self.chunkArray(items, self.PAGE_SIZE)
  // 								: [];

  // 						self.setState({ pagedData: pagedData });
  // 						var itemsPaginated = pagedData[pageNum - 1] || [];
  // 						self.setState({ items: itemsPaginated });
  // 					}
  // 				} else {
  // 					console.log("err in fetch");
  // 				}
  // 			} else {
  // 				console.log("err in fetch");
  // 			}
  // 		});
  // }

  chunkArray(array, size) {
    //Chunk array for pagination
    const chunked_arr = [];
    let copied = [...array]; // ES6 destructuring
    const numOfChild = Math.ceil(copied.length / size); // Round up to the nearest integer
    for (let i = 0; i < numOfChild; i++) {
      chunked_arr.push(copied.splice(0, size));
    }

    return chunked_arr;
  }

  render() {
    let hasItems = this.state.items.length == 0 ? false : true;
    return (
      <React.Fragment>
        <Loader loading={this.state.loading} />
        <div ref={this.myRef}></div>
        <Header history={this.props.history} />
        <Container fluid className="container-fluid-px py-6">
          <Row>
            <Col xl="9" lg="8" className="products-grid order-lg-2">
              <div className="hero-content pb-5">
                <h1>{this.state.categoryName}</h1>
                <Row>
                  <Col xl="8">
                    <p className="lead text-muted">{this.state.description}</p>
                    <div className="card-body">
                      {/* Total react packages: {totalReactPackages} */}
                    </div>
                  </Col>
                </Row>
              </div>

              <Breadcrumb>
                <BreadcrumbItem>
                  <a href="/home">
                    Home
                  </a>
                </BreadcrumbItem>
                <BreadcrumbItem active>
                  {this.state.categoryName}
                </BreadcrumbItem>
              </Breadcrumb>
              <div className="mb-3 d-flex align-items-center">
                <span className="d-inline-block mr-2">Sort by</span>
                <Select
                  name="sort"
                  options={this.options}
                  defaultValue={this.state.sortOption}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  styles={this.customSelectStyles}
                  isSearchable={false}
                  onChange={this.handleSort}
                  value={this.state.sortOption}
                />
              </div>

              {hasItems && (
                <EqualHeight timeout="1500">

                  <Row>
                    {this.state.items.map((product, index) => (

                      <Col key={index} sm="4" xl="3" xs="6">

                        <CardProduct product={product} updateCartCount={this.updateCartCount} />

                      </Col>

                    ))}
                  </Row>
                </EqualHeight>

              )}
              {!hasItems && (
                <div>
                  <Jumbotron fluid>
                    <Container fluid>
                      <p className="lead">No Items Found</p>
                    </Container>
                  </Jumbotron>
                </div>
              )}

              <div className="pagination-wrapper">
                {hasItems && (
                  <Pagination className="d-flex justify-content-center mb-5 mt-3">
                    <PaginationItem
                      className="page-arrow"
                      disabled={this.state.currentPage <= 0}
                      onClick={(e) =>
                        this.handleClick(e, this.state.currentPage - 1)
                      }
                    >

                      {/* <a className="page-arrow" href="#">
                        <span aria-hidden="true">
                          <Icon icon="angle-left-1" className="page-icon" />
                        </span>

                        <PaginationLink
                          className="sr-only"
                          onClick={(e) =>
                            this.handleClick(e, this.state.currentPage - 1)
                          }
                          previous
                          href="#"
                        />
                        <span className="sr-only">Previous</span>
                      </a> */}
                      <span className="page-arrow">
                        <span aria-hidden="true">
                          <Icon icon="angle-left-1" className="page-icon" />
                        </span>

                        <PaginationLink
                          className="sr-only"
                          onClick={(e) =>
                            this.handleClick(e, this.state.currentPage - 1)
                          }
                          previous
                          href="#"
                        />
                        <span className="sr-only">Previous</span>
                      </span>
                    </PaginationItem>

                    {this.state.pagedData.map((page, i) => (
                      <PaginationItem
                        active={i === this.state.currentPage}
                        key={i}
                      >
                        <PaginationLink
                          onClick={(e) => this.handleClick(e, i)}
                          href="#"
                        >
                          {i + 1}
                        </PaginationLink>
                      </PaginationItem>
                    ))}

                    <PaginationItem
                      className="page-arrow"
                      disabled={
                        this.state.currentPage >=
                        this.state.pagedData.length - 1
                      }
                      onClick={(e) =>
                        this.handleClick(e, this.state.currentPage + 1)
                      }
                    >

                      {/* <a className="page-arrow" href="#">
                        <span aria-hidden="true">
                          <Icon icon="angle-right-1" className="page-icon" />
                        </span>
                        <PaginationLink
                          className="sr-only"
                          onClick={(e) =>
                            this.handleClick(e, this.state.currentPage + 1)
                          }
                          next
                          href="#"
                        />
                        <span className="sr-only">Next</span>
                      </a> */}
                      <span className="page-arrow">
                        <span aria-hidden="true">
                          <Icon icon="angle-right-1" className="page-icon" />
                        </span>
                        <PaginationLink
                          className="sr-only"
                          onClick={(e) =>
                            this.handleClick(e, this.state.currentPage + 1)
                          }
                          next
                          href="#"
                        />
                        <span className="sr-only">Next</span>
                      </span>
                    </PaginationItem>
                  </Pagination>
                )}
              </div>
            </Col>
            <Col xl="3" lg="4" className="sidebar pr-xl-5 order-lg-1">
              {/* <div key={'stock'}>
                <div className="sidebar-block px-3 px-lg-0">
                  <Collapse
                    isOpen={this.state.collapse['stock']}
                    className="expand-lg"
                  >
                    <h5 className="sidebar-heading d-none d-lg-block">
                      Filter By stock
                    </h5>

                    In Stock
                  </Collapse>
                </div>

              </div> */}
              <Button
                color="dark px-3 px-lg-0 mt-3 mb-5"
                block
                type="button"
                onClick={this.onFilterSubmit}
              >
                Apply Filters
              </Button>
              {this.state.sidebarFilters.map((filter, index) => (
                <div key={index}>
                  {filter.show && (
                    <div className="sidebar-block px-3 px-lg-0">
                      <a
                        className="d-lg-none block-toggler plp-filter"
                        aria-expanded={this.state.collapse[filter.subtitle]}
                        onClick={() => this.toggleCollapse(filter.subtitle)}
                      >
                        {filter.title}
                        <span className="block-toggler-icon" />
                      </a>

                      <Collapse
                        isOpen={this.state.collapse[filter.subtitle]}
                        className="expand-lg"
                      >
                        <h5 className="sidebar-heading d-none d-lg-block">
                          {filter.title}
                        </h5>

                        {filter.component}
                      </Collapse>
                    </div>
                  )}
                </div>
              ))}

              <div className="sidebar-block px-3 px-lg-0">
                <h5 className="sidebar-heading ">Filter by Price</h5>
                <Nouislider
                  key={2}
                  range={{
                    min: this.state.priceStartRange,
                    max: this.state.priceEndRange,
                  }}
                  start={[this.priceMin, this.priceMax]}
                  onUpdate={this.priceSlider}
                  className="mt-4 mt-lg-0"
                  connect
                />
                <div className="nouislider-values mb-4">
                  <div className="min">
                    From $
                    <span id="slider-snap-value-from">
                      {this.state.priceMin}
                    </span>
                  </div>
                  <div className="max">
                    To $
                    <span id="slider-snap-value-to">{this.state.priceMax}</span>
                  </div>
                </div>

                {/* <Button
                  color="dark px-3 px-lg-0 mt-5"
                  block
                  type="button"
                  onClick={this.onFilterSubmit}
                >
                  Apply Filters
                </Button> */}
              </div>
            </Col>
          </Row>
        </Container>
        <Footer />
      </React.Fragment>
    );
  }
}

export default CategoryFull;
